module.exports = __webpack_public_path__ + "img/partner-8.07a50fd0.svg";